import { AxiosResponse } from 'axios';
import { environmentUtils } from 'utils';
import { SESSION_STORAGE_KEYS } from 'constants/defaultValues';
import AxiosInstanceBFF from './AxiosInstanceBFF';

const unSubscribeWebPushUrl = 'v1/web-push/unsubscribe';

export const unSubscribeWebPush = async (): Promise<AxiosResponse<string>> => {
  const instanceId = environmentUtils.getEnvironmentInstance() || '';
  const userId = sessionStorage.getItem(SESSION_STORAGE_KEYS.USER_ID) || '';
  const body = {
    instanceId,
    userId,
  };
  return AxiosInstanceBFF.post(unSubscribeWebPushUrl, body);
};
